/* eslint-disable */
import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import Select from 'react-select';
import 'chart.js/auto';
import './staffingProjections.scss';

const StaffingProjection = () => {
  const [selectedOption, setSelectedOption] = useState({
    value: 'q3',
    label: 'Time Frame: Q3',
  });

  const filterOptions = [
    { value: 'q3', label: 'Time Frame: Q3' },
    { value: 'q4', label: 'Time Frame: Q4' },
    { value: 'yearly', label: 'Time Frame: Yearly' },
  ];

  const data = {
    labels: [
      'FE Dev',
      'BE Dev',
      'PMO',
      'Quality',
      'Design',
      'Finance',
      'Other',
    ],
    datasets: [
      {
        label: 'Demand - Junior',
        data: [8, 1, 6, 1, 8, 6, 1],
        backgroundColor: '#6B5CE8',
        borderRadius: 10,
        barThickness: 30,
      },
      {
        label: 'Demand - Mid Level',
        data: [10, 7, 1, 1, 1, 1, 2],
        backgroundColor: '#E8A700',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Release',
      },
      {
        label: 'To Be Released - High',
        data: [4, 1, 1, 9, 1, 1, 1],
        backgroundColor: '#FDE9B6',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Release',
      },
      {
        label: 'To Be Released - Junior',
        data: [10, 4, 12, 5, 7, 1, 1],
        backgroundColor: '#08B758',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Bench',
      },
      {
        label: 'Bench - Mid Level',
        data: [1, 1, 1, 1, 1, 1, 1],
        backgroundColor: '#43D590',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Bench',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#FFFFFF',
        titleColor: '#1D1B20',
        bodyColor: '#888888',
        borderColor: '#DDD',
        borderWidth: 1,
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          color: '#666',
          font: {
            size: 12,
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            if ([0, 5, 10, 15, 20].includes(value)) return value;
          },
          stepSize: 5,
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
          borderDash: [5, 5],
        },
      },
    },
  };

  return (
    <div className="staffing-projection-container">
      <div className="header">
        <h2 className="title">Staffing Projection</h2>
        <div className="header-row">
          <p className="date"></p>
          <Select
            className="filter-dropdown"
            classNamePrefix="custom-dropdown"
            value={selectedOption}
            onChange={setSelectedOption}
            options={filterOptions}
          />
        </div>
      </div>

      <div className="chart-container">
        <Bar data={data} options={options} />
        <div className="custom-legend">
          <div className="legend-items">
            <div className="legend-item">
              <div className="legend-icon demand"></div>
              <span className="legend-label">Demand</span>
            </div>
            <div className="legend-item">
              <div className="legend-icon to-be-released"></div>
              <span className="legend-label">To Be Released</span>
            </div>
            <div className="legend-item">
              <div className="legend-icon bench"></div>
              <span className="legend-label">Bench</span>
            </div>
          </div>
          <p className="legend-note">Note: * denotes multi-skilled employees</p>
        </div>
      </div>
    </div>
  );
};

export default StaffingProjection;
